import { gql } from "@apollo/client";

export const GET_ESTIMATED_GAS_FEE = gql`
  query EstimatedGasFee($queryInput: EstimatedGasFeeQueryInput) {
    estimatedGasFee(queryInput: $queryInput) {
     estimatedGasFee
    }
  }
`;
